export default {
  General: {
    Email: "E-mail",
    Send: "Envoyer",
    Done: "Terminé",
    Finish: "Terminer",
    Try_again: "Réessayer",
    or: "ou"
  },
  SamsungType: {
    bixby: "Avec Bixby",
    no_bixby: "Sans Bixby",
    home_button: "Bouton Accueil"
  },
  sendEmail: {
    repair_tip1: "Ce modèle ne peut pas être réparé avec l'application mobile. Nous vous enverrons l'application de bureau par e-mail.",
    check_tip1: "La vérification de l’appareil ne peut pas être effectuée uniquement via l’application mobile. Nous vous enverrons la solution de bureau par e-mail.",
    tip1: "Ce modèle ne peut pas être déverrouillé avec l'application mobile. Nous vous enverrons l'application de bureau par e-mail.",
    tip2: "Nous vous conseillons de connecter votre téléphone à votre ordinateur à l'aide d'un câble de données.",
    enter_address: "Saisissez votre adresse e-mail.",
    enter_correct_address: "Veuillez entrer l'adresse e-mail correcte.",
    confidential: "Votre e-mail restera strictement confidentiel.",
    open_link: "Ouvrez le lien {0} sur n'importe quel ordinateur pour télécharger Dr.Fone.",
    has_sent: "Votre e-mail a été envoyé.",
    almost: "Vous y êtes presque.",
    step1: "Étape 1",
    open_email: "Ouvrez l'e-mail sur votre ordinateur et utilisez le lien qu'il contient pour télécharger le logiciel Dr.Fone.",
    step2: "Étape 2",
    repair_launch_tip: "Lancez Dr.Fone System Repair et connectez-vous à votre compte pour utiliser la fonction de réparation.",
    check_launch_tip: "Installez la version de bureau de Dr.Fone et connectez-vous avec le même compte. Cliquez sur « My Device », puis suivez les instructions à l’écran pour connecter votre appareil. Une fois la connexion établie, cliquez sur « Device Detail » pour voir les résultats de vérification détaillés.",
    launch_tip: "Lancez le Déverrouillage Dr.Fone et connectez-vous pour utiliser cette fonctionnalité.",
    contact_us: "Contactez-nous pour obtenir de l'aide."
  },
  Unlock: {
    recoveryMode: "Mettez votre appareil en mode de récupération",
    wipe_cache: "Supprimez le cache système sur votre appareil",
    wipe_data: "Suivez les instructions pour effacer les données de votre appareil",
    completed: "Déverrouillage terminé",
    completed_tip: "Vérifiez que votre appareil a bien supprimé le verrouillage de l'écran. En cas d'échec, veuillez réessayer.",
    contact_us: "Échec du déverrouillage ? Contactez-nous pour obtenir de l'aide."
  },
  UnlockStep: {
    sa1: "1. Éteignez le téléphone et laissez-le connecté à l'ordinateur. ",
    sa2: "2. Maintenez enfoncés les boutons Volume +, Bixby et Marche/Arrêt.",
    sa3: "3. Relâchez les boutons lorsque le logo Samsung s'affiche et patientez quelques secondes.",
    sa4: "4. Votre appareil devrait maintenant démarrer en mode de récupération. Choisissez « Reboot to bootloader » pour passer en mode de téléchargement.",
    sb1: "1. Éteignez le téléphone et laissez-le connecté à l'ordinateur.",
    sb2: "2. Maintenez enfoncés les boutons Marche/Arrêt et Volume +.",
    sb3: "3. Maintenez ces deux boutons enfoncés même après le redémarrage de l'appareil.",
    sb4: "4. Votre appareil devrait maintenant démarrer en mode de récupération. Choisissez « Reboot to bootloader » pour passer en mode de téléchargement.",
    sc1: "1. Éteignez le téléphone et laissez-le connecté à l'ordinateur.",
    sc2: "2. Maintenez enfoncés les boutons Volume +, Accueil et Marche/Arrêt.",
    sc3: "3. Relâchez les boutons lorsque le logo Samsung s'affiche et patientez quelques secondes.",
    sc4: "4. Votre appareil devrait maintenant démarrer en mode de récupération. Choisissez « Reboot to bootloader » pour passer en mode de téléchargement.",
    s5: "5. Appuyez sur le bouton Volume pour sélectionner « Wipe data/factory reset », puis appuyez sur le bouton Marche/Arrêt pour confirmer.",
    s6: "6. Appuyez sur le bouton Volume pour sélectionner « Yes », puis appuyez sur le bouton Marche/Arrêt pour confirmer.",
    s7: "7. Appuyez sur « Wipe cache partition », puis sélectionnez « Yes ».",
    s8: "8. Sélectionnez « reboot system now » et appuyez sur le bouton Marche/Arrêt pour confirmer. Le redémarrage de l'appareil prend un certain temps.",
    common1: "Éteignez votre téléphone.",
    common2: "Appuyez sur les boutons Volume + et Marche/Arrêt pendant quelques secondes.",
    common3: "Relâchez les boutons lorsque le mode de récupération s'affiche à l'écran.",
    m4: "Sélectionnez « Wipe Data » à l'aide des touches Volume et Marche/Arrêt pour accepter.",
    m5: "Choisissez « Wipe All Data ».",
    m6: "Choisissez maintenant « Confirm » et attendez la fin du processus.",
    m7: "Revenez au menu principal à l'aide du bouton Marche/Arrêt.",
    m8: "Sélectionnez « Reboot ».",
    m9: "Enfin, choisissez « Reboot to system ».",
    h4: "Sélectionnez « Clear Data » à l'aide des touches Volume et Marche/Arrêt pour accepter.",
    h5: "Sélectionnez « Factory reset ».",
    h6: "Saisissez le mot « yes », puis sélectionnez « Factory reset ».",
    h7: "Au cours de cette opération, tous vos fichiers seront supprimés.",
    h8: "Sélectionnez « Back » pour revenir au menu principal.",
    h9: "Enfin, choisissez « Restart »."
  }
};
